export const TRANSLATIONS_EN = {
  leftNavigation: {
    dashboard: "Dashboard",
    sessions: "Sessions",
    teams: "Teams",
    profile: "Profile",
    logs: "Logs",
    warningLetters: "Warning Letters",
    settings: "Settings",
    userManagement: "User Management",
    subjectManagement: "Subject Management",
    changePassword: "Change password",
    helpAndSupport: "Help and support",
    scoresheet: "Scoresheet",
    campaignManagement: "Campaign Management",
    regionManagement: "Region Management",
    changeSecurityQuestion: "Recovery Access",
    overallCoachingReport: "Overall Coaching Report",
  },
  header: {
    logout: "Logout",
    notifications: "Notifications",
    loadingNotifications: "Loading notifications....",
    stepper: {
      plan: "Plan",
      do: "Do",
      check: "Check",
      act: "Act",
    },
  },
  tabs: {
    ceo: "CEO",
    executive: "Executive",
    coe: "COE",
    campaign: "Functional Unit",
    team: "Team",
    personal: "Personal",
  },
  notification: {
    session: "You have a coaching session with ",
    on: "on ",
    checkpointUpdated: "has updated the checkpoint date",
    complete: "Please complete the GROW Model by",
    growmodel: "has completed the GROW Model and accepted your invitation",
    progression: "has updated Your progression ",
    compliment: "gave you a compliment!'",
    rating: "Please rate your coaching session with",
    review: "has changed your final review date to",
    archivedSession: "has rated and archived the coaching session!",
    checkpoint: "Checkpoint",
    updateFor: "update for",
    isAvailable: "is available",
    at: "at",
    today: "today",
    youHaveYetToSetCheckPoint: "You have yet to set checkpoint for",
    by: "by",
    youHaveAReviewSessionWith: "You have a review session with",
    youHaveUpcomingSession: "You have an upcoming session with",
    youHaveCompleted: "You have completed",
    sessionCompletedLastMonth: "session(s) in the last month",
  },
  dashboard: {
    title: "Dashboard",
    noDataYet: "No data yet",
    tabs: {
      ceo: "CEO",
      executive: "Executive",
      coe: "COE",
      campaign: "Functional Unit",
      team: "Team",
      personal: "Personal",
    },
    coachingSessionWith: "Coaching Session With",
    checkpointSetupFor: "Checkpoint setup for",
    checkpointUpdateFor: "Checkpoint update for",
    reviewSessionWith: "Review session with",
    average: "Average",
    longest: "Longest",
    shortest: "Shortest",
    executive: {
      sessionClosed: "Session closed",
      overall: "Overall",
      totalInprogress: "Total sessions in progress",
      avgUsageRate: "Avg usage rate",
      usageRate: "Usage rate",
      totalSessionClosed: "Total sessions completed",
      totalCoachees: "Total coachees",
      avgSessionClosed: "Avg session closed",
      coachingHours: "Coaching hours",
      totalCoachingHours: "Total coaching hours",
      avgCoachingHours: "Average coaching hours",
      totalPlanDuration: "Total Plan duration",
      totalDoDuration: "Total Do duration",
      totalCheckDuration: "Total Check duration",
      totalActDuration: "Total Act duration",
      coachingSubjects: "Coaching subjects",
    },
    coach: {
      dashboard: "Dashboard",
      report: "Report",
      upcomingTask: "Upcoming task",
      overdueTask: "Overdue task",
      recentTask: "Recent activities",
      top3coaches: "Top 3 coaches",
      campaignSession: "Functional Unit's Session",
      totalCoach: "Total Coachees",
      coached2OrMoreSession: "Coached for 2 or more sessions",
      coached1Session: "Coached for 1 session",
      notCoachedYet: "Not coached yet",
      showResultFor: "Show results for",
      happiness: "Satisfaction",
      complimentLikes: "Compliment likes",
      success: "Session Success",
      ratedSession: "Rated session",
      totalSession: "Total sessions",
      likes: "Likes",
      totalComplements: "Total Compliments",
      passRate: "Pass rate",
      totalSubjects: "Total subjects",
      comparedTo: "Compared to",
      department: "Department",
      reportingLine: "Reporting line",
      mostCoachedSubjects: "Most coached subjects",
      average: "Average",
      mostFailedSubjects: "Most failed subjects",
      topSkillsToImprove: "Top skills to improve",
      teamAverage: "Team average",
      coach: "Coach",
      typeOfSession: "Type of sessions",
      subjects: "Subjects",
      session: "Sessions",
      sessionDuration: "Session duration",
      length: "Length",
      minutes: "Minutes",
      longest: "Longest",
      shortest: "Shortest",
      plan: "Plan",
      do: "Do",
      check: "Check",
      act: "Act",
      total: "Total",
      individual: "Individual",
      metricsHead: "Team members' coached sessions",
      complianceRate: "Compliance Rate",
      incompleteRate: "Incomplete Rate",
      conditionalPassRate: "Conditional pass rate",
      campaign: "Functional Unit",
      sessions: "Sessions",
      manual: "Manual",
      expired: "Expired",
      team: "Team",
      campaignAverage: "Functional Unit Average",
      topCountries: "Top countries",
    },
    personal: {
      dashboard: "Dashboard",
      showResultFor: "Show result for",
      happiness: "Satisfaction",
      complimentLikes: "Compliment likes",
      success: "Session Success",
      kpisuccess: "Project Target KPI Success",
      ratedSession: "Rated Session",
      totalSession: "Total Sessions",
      likes: "Likes",
      totalComplements: "Total compliments",
      passRate: "Pass rate",
      totalSubjects: "Total subjects",
      latestCompliments: "Compliments",
      comparedToTeamAvg: "Compared to team average",
      mostCoachedSubjects: "Most coached subjects",
      mostFailedSubjects: "Most failed subjects",
      topSkillsToImprove: "Top skills to improve",
      individual: "Individual",
      teamAverage: "Team average",
      subjects: "Subjects",
      session: "Sessions",
      personalmetricsHead: "Your coaching sessions(current month)",
    },
    tooltip: {
      teamAverage:
        "As compared to the average number of sessions completed by coachees in your team.",
    },
    selectReport: "Select Report",
    overallCoachingSessionsReport: "Overall Coaching Sessions Report",
    sessionDiscussionReport: "Session Discussion Report",
    monthly: "Monthly",
    custom: "Custom",
    cancel: "Cancel",
    download: "Download",
  },
  sessionList: {
    title: "Sessions",
    totalSessionPending: "Total sessions pending",
    allCoaches: "All coaches",
    allStatus: "All status",
    upcomingSession: "Upcoming event date",
    sessionDateTime: "Session date",
    time: "Time",
    type: "Type Of Session",
    subjects: "Subject(s)",
    coach: "Coach",
    coachID: "Coach Employee ID",
    coachee: "Coachee",
    coacheeID: "Coachee Employee ID",
    status: "Status",
    createSession: "CREATE SESSION",
    allCountries: "All Countries",
    allCampaign: "All Functional Units",
    sessionSuccess: "Session successfully ended",
    name: "Name",
    employeeID: "Employee ID",
  },
  createSession: {
    backToSession: "BACK TO SESSIONS",
    createNewSession: "Create new session",
    campaign: "Functional Unit",
    coachee: "Coachee",
    coach: "Coach",
    assignToOtherCoach: "Assign to other coach",
    assignTo: "Assign to",
    selectTeamMember: "Select a team member",
    viewCoacheesStates: "View Historical Coachee Logs",
    coachingDate: "Coaching date",
    mode: "Mode",
    framework: "Framework",
    reviewDate: "Review date",
    typeOfSession: "Type of sessions",
    addSubjects: "Add Subjects",
    sessionNotes: "Session notes",
    keyPoint: "Key point",
    addNewNote: "Add a new note",
    compliment: "Compliment",
    casualNote: "Casual note",
    createSendInvitation: "Create and send invitation",
    assignFieldMandatory: "Assign field is mandatory",
    coacheeFieldMandatory: "coachee field is mandatory",
    logs: "Logs",
    complettionDate: "Completion date",
    duration: "Duration",
    type: "Type",
    subjects: "Subjects",
    name: "Name",
    status: "Status",
    noTeamLogsFound: "No Teams Logs Found",
    close: "Close",
    modeIsMandatory: "Mode is mandatory",
    frameworkIsMandatory: "Framework is mandatory",
    sessionTypeIsMandatory: "Session Type is mandatory",
    pleaseAddAtLeastOneSubject: "Please add at least one subject",
    selectAcoach: "Select a coach",
    ErrorNetworkError: "Error: Network Error",
    notes: "Notes",
  },
  sessionDetails: {
    backtosession: "BACK TO SESSIONS",
    sessionDetails: "Session details",
    coach: "Coach",
    coachee: "Coachee",
    caochingDate: "Coaching date",
    reviewDate: "Review date",
    typeofSession: "Type of sessions",
    subjects: "Subjects",
    gentleReminderTitle: "Gentle Reminder",
    gentleReminder:
      "Gentle Reminder: read the key points on the right panel before starting your session preparation.",
    startPreparation: "Start preparation",
  },
  pii: {
    errorMessage:
      "Sensitive information detected.",
    markAsSafeTooltip: "Mark as safe",
    cancel: "Cancel",
    reasonNotPersonalInformation: "Not personal information",
    reasonTestOrSampleData: "Test or sample data",
    reasonTechnicalOrSystemData: "Technical or system data",
    reasonAlreadyMasked: "Already hidden or masked",
    reasonOther: "Other",
    removeOrMarkSafe: "Remove information or mark as safe",
    markAsSafeTitle: "Mark detection as safe",
    markAsSafeSubtitle: "Help us understand why this is not sensitive.",
    otherReasonPlaceholder: "Describe why it's safe",
    addDescriptionError: "Add a description",
    submit: "Submit",
    labelEmail: "Email",
    labelPhone: "Phone number",
    labelNationalId: "ID number",
    labelPassport: "Passport number",
    labelPaymentCard: "Card number",
    labelBankAccount: "Bank account number",
    labelName: "Name",
    labelCampaign: "Campaign",
    labelCompany: "Client company",
    labelSubFunctionalUnit: "Sub functional unit",
  },
  growForm: {
    planSessionBasedonGrowModel: "Plan session based on GROW Model",
    planSessionBasedonConversationalModel:
      "Plan session based on Conversational Model",
    yourReviewSessionIsOn: "Your review session is on",
    goals: "Goals",
    comment: "Comment",
    knowingYourCoachingSubjectsAndCreate:
      "Knowing your coaching subjects and create a plan to meet the target by the review date, using SMART Goals.",
    SMARTGolasIsAnEstablished:
      "SMART Goals is an established way to plan and achieve goals. Creating SMART Goals aids to create a realization of what you want to accomplish, how your goals can be achieved, if your goals can be done and relevant, and when do you want to accomplish your goals",
    reality: "Reality",
    current: " Current metric",
    enterMetrics: "Enter metric",
    target: "Coachee’s target metric",
    enterTarget: "Enter target metric",
    knowingYourCurrentPerformance:
      "Knowing your current performance relating to your coaching subjects.",
    options: "Options",
    brainstormForMultipleOptionsToImprove:
      "Brainstorm for multiple options to improve coaching subjects to achieve targets. Enumerate possible techniques that can help close areas of opportunity. This stage encourages creativity in exploring possible solutions",
    wayForward: "Way forward",
    selectTheMostFeasibleOptions:
      "Select the most feasible options that can reach your goals successfully.",
    saveAndConfirmSession: "Save and confirm session",
    startCoachingSession: "Start coaching session",
    edit: "Edit",
    startCoaching: "Start Coaching",
    proceedToSummary: "Proceed to summary",
    skillToImprove: "Skill to improve",
    selectSkill: "Select skill",
    pleaseSelectSkillsToImprove: "Please Select Skills to improve",
    enterProjectKpi: "Enter KPI",
    projectTargetKpi: "Project Target KPI",
    targetKpi: "Target KPI",
    mtd: "MTD Metric",
    enterMtdMetrics: "Enter metric",
    save: "Save",
    question: "Question",
    nextQuestion: "Next question",
    done: "Done",
    kickstartQuestion:
      "The Kickstart Question: What’s on Your Mind in terms of improving your performance?",
    subkickstartquestion:
      "Helps focus on the performance issue at hand that needs improving",
    theAweQuestion:
      "The AWE Question: And What Else can be done to reach the desired performance outcome?",
    theAweQuestionans:
      "To generate greater understanding on the performance issue that needs to be addressed",
    thefocusQuestion:
      "The Focus Question: What’s the Real Challenge for you in achieving your performance goal?",
    thefocusQuestionans:
      "Uncovers a deeper underlying issue that could impede achieving the performance goal",
    thefoudationQuestion:
      "The Foundation Question: What do you Want/Need to attain your performance goal?",
    thefoudationQuestionans:
      "Takes one to the main challenge on what needs to be done and why, to achieve the performance goal",
    thelazyQuestion:
      "The Lazy Question: How can I help you Achieve your performance goal?",
    thelazyQuestionans:
      "Allows the employees to make a direct request of what you can do, to help them achieve their performance goal",
    thestrategicQuestion:
      "The Strategic Question: What are the things you WILL do and NOT do, to accomplish your performance goal",
    thestrategicQuestionans:
      "Employee is directed to commit and in doing so, will need to carefully examine the implications of the choices made to attain the performance goal",
    thelearningQuestion:
      "The Learning Question: What is the most Useful or Valuable lesson here for you?",
    thelearningQuestionans:
      "Getting feedback on what could truly work in accomplishing the performance outcome",

    // Default Questions
    question1: "What’s on Your Mind to achieve your performance goal?",
    question2: "And What Else can be done?",
    question3: "What’s the Real Challenge here for you?",
    question4: "What do you Need to Do to attain your goal?",
    question5: "How can your Supervisor help you?",
    question6:
      "What are the things you WILL do and NOT do, to accomplish your goal?",
    question7: "What is the Most Useful lesson here for you?",

    // Question Labels
    label1: "Focus on the performance issue at hand that needs improving",
    label2:
      "Generate greater understanding on the issues that need to be addressed",
    label3:
      "Uncover deeper underlying issues that could impede achieving the goal",
    label4: "What needs to be done and why, to achieve the goal",
    label5:
      "Make a direct request to the Supervisor to help you achieve your goal",
    label6:
      "Commit to actions after carefully examining the implications of the choices made to attain the goal",
    label7: "Reflect on what could truly work to achieve the goal",
    reality_optional:
      "(Optional)\nWhat's been going well at work?\nWhat challenges have you been facing?\nWhat would you most like help with?",
  },
  coachingSummary: {
    coachingSummary: "Coaching summary",
    coach: "Coach",
    coachee: "Coachee",
    coachingDate: "Coaching date",
    mode: "Mode",
    typeOfSession: "Type of sessions",
    goals: "Goals",
    reality: "Reality",
    current: "Current",
    target: "Target",
    skillToImprove: "Skill to improve",
    options: "Options",
    wayForward: "Way forward",
    yourReviewSessionWillBe: "Your review session will be on",
    progressionCheckpoints:
      "Progression checkpoints will be set and updated by your coach before your review date.",
    acknowledgement: "Acknowledgement",
    enterPassword: "Enter password",
    pleaseEnterPassword: "Please enter your password",
    endCoaching: "End Coaching",
    byAcknowledgingthisGrow:
      "By acknowledging this GROW form, you are agreeing to work on the action plan stated.",
    cancel: "Cancel",
    agree: "Agree",
  },
  setCheckpoint: {
    backToSession: "BACK TO SESSIONS",
    setCheckpoint: "Set checkpoints",
    viewSessionSummary: "View session summary",
    rateCoacheesBehaviour: "Rate coaching session",
    checkpoint: "Checkpoint",
    addCheckpoint: "ADD CHECKPOINT",
    reviewDate: "Review date",
    gentleReminder:
      "Gentle Reminder: You won’t be able to change your rating after you have confirmed.",
    pleaseRateTheCoachees: "Please rate the coachee's behavior.",
    confirmRatingAndCheckpoints: "Confirm rating and checkpoints",
  },
  sessionSummary: {
    viewSessionSummary: "View session summary",
    coachingDate: "Coaching date",
    mode: "Mode",
    typeOfSession: "Type of sessions",
    goals: "Goals",
    reality: "Reality",
    current: "Current",
    target: "Target",
    skillsToImprove: "Skills to improve",
    options: "Options",
    wayForward: "Way forward",
    reminder: "Reminder",
    reminderNotification:
      "Remember to address any absenteeism and/or punctuality issues where necessary.",
  },
  updateCheckpoint: {
    updateCheckpoint: "Update checkpoint scores",
    edit: "Edit",
    viewSessionSummary: "View session summary",
    reviewDate: "Review date",
    checkpoint: "Checkpoint",
    final: "Final",
    previous: "Previous",
    checkpointProgressScore:
      "Checkpoint Progress Score has been saved successfull",
    saveProgress: "Save progress score",
    startReviewSession: "Start review session",
    rescheduleReviewSession: "Reschedule review session",
    rescheduleReviewSessionTo: "Reschedule review session to",
    pleaseStateReason: "Please state reason",
    cancel: "Cancel",
    schedule: "Schedule",
  },
  editSessionCoachingDates: {
    title: "Postpone Session Dates",
    update: "Update",
  },
  deleteSession: {
    title: "Delete This Session",
    message:
      "Once this session has been deleted, you will not be able to restore it. If you're sure, go ahead and input a valid reason to continue.",
    reasonPlaceholder:
      'Enter your reason here, for example: "Coachee no longer requires session"',
    deleteSession: "Delete session",
    cancel: "Cancel",
    delete: "Delete",
    sessionSuccessfullyDeleted: "Session successfully deleted",
    reasonMandatory: "The reason is mandatory",
    textLimit: "Your reason shouldn't exceed 200 characters",
  },
  reviewSession: {
    reviewSession: "Review session",
    finalReview: "Final review",
    final: "Final",
    summary: "Summary",
    aiSummary: "AI summary",
    aiSubtitle:
      "AI-generated content may contain errors. Do review before using",
    summaryCopiedToClipboard: "Summary copied to clipboard",
    failedToGenerateSummary: "Oops, something went wrong.",
    tryAgain: "Try again",
    feedbackSubmitted: "Feedback submitted",
    failedToSendFeedback: "Failed to send feedback",
    coachSummary: "Coach's summary",
    proceedToSummary: "Proceed to summary",
    summaryFieldIsRequired: "Summary is field is required",
    sessionReviewSummarySavedSuccessfully:
      "Session review summary saved successfully!",
    coachSummaryPlaceholder: "Summarize coaching outcomes and next steps",
    replaceSummaryTitle: "Replace summary?",
    replaceSummaryBody: "Want to replace your existing summary with the AI-generated version?",
    replace: "Replace",
    coachSummaryPlaceholder: "Summarize coaching outcomes and next steps",
    endReviewSession: "End review session",
    done: "Done..!",
    insert: "Use summary",
  },
  archiveSession: {
    backtoSession: "Back to Session",
    backToLog: "Back to Logs",
    archiveSession: "Archive Session",
    incompleteSession: "Incomplete Session Details",
    areYouSatisfied: "Are you satisfied with this session?",
    pleaseReadTHeSessionSummary:
      'Please read the session summary and notes carefully. You can no longer "like" the compliments notes once this session has been archived',
    totalDuration: "Total Duration",
    durationBreakdown: "Duration Breakdown",
    viewReviewSessionSummary: "View review session summary",
    coacheesBehaviour: "Session rating",
    reviewDate: "Review date",
    finalReview: "Final review",
    summary: "Summary",
    notes: "Notes",
    selectYourFeedback: "Select your feedback",
  },
  personalProfile: {
    fullName: "Full Name",
    employeeID: "Employee ID",
    campaign: "Functional Unit",
    market: "Market",
    designation: "Designation",
    coach: "Coach",
    viewSession: "View sessions",
    viewLogs: "View logs",
    personalProfile: "Personal profile",
  },
  teams: {
    coach: "Coach",
    taggedCoaches: "Tagged Coachees",
    untaggedCoachees: "Untagged Coachees",
    searchFilter: "Search filter",
    employeeId: "Employee Id",
    Campaign: "Functional Unit",
    department: "Department",
    subunit: "Sub Functional Unit",
    lastSession: "Last Session",
    upcommingSession: "Upcoming Session",
    totalCoachees: "Total coachees",
    members: "Members",
    coaches: "Coaches",
    allCountries: "All Countries",
    allCampign: "All Campign",
    teams: "Teams",
    name: "Name",
  },
  logs: {
    allCoaches: "All coaches",
    searchFilter: "Search filter",
    completionDate: "Completion date",
    sessionStartDate: "Start date",
    duration: "Duration",
    subjects: "Subjects",
    type: "Type Of Session",
    coach: "Coach",
    coachID: "Coach Employee ID",
    coachee: "Coachee",
    coacheeID: "Coachee Employee ID",
    status: "Status",
    totalLogs: "Total logs",
    averageDuration: "Average duration (mins)",
    longestDuration: "Longest duration (mins)",
    shortestDuration: "Shortest duration (mins)",
    filter: "Filter",
    names: "Names",
    name: "Name",
    employeeID: "Employee ID",
    clearAll: "Clear all",
    allCountries: "All countries",
    AllCampaign: "All functional unit",
  },
  userManagement: {
    searchFilter: "Search filter",
    name: "Name",
    id: "Id",
    campaign: "Functional Unit",
    department: "Department",
    country: "Country",
    designation: "Designation",
    role: "Role",
    status: "Status",
    editUser: "Edit User",
    fullName: "Full Name",
    employeeID: "Employee ID",
    adminRole: "Admin Role",
    allRoles: "All Roles",
    allAdminRoles: "All Admin Roles",
    allStatuses: "All Statuses",
    managerCoache: "Manage Coachee",
    AddCoach: "Add Coach",
    userStatus: "User Status",
    userBlock: "User Block",
    resetPassword: "Reset Password",
    sendgridStatus: "SendGrid Status",
    sendgridCheck: "Check SendGrid Status",
    sendgridSuppressionCleared: "SendGrid Suppression Cleared",
    sendgridCheckError: "An error occurred while checking SendGrid status",
    blocks: "Blocks",
    bounces: "Bounces",
    sendgridClear: "Clear Suppression",
    sendgridClearError: "An error occurred while clearing SendGrid suppression",
    saveChanges: "Save Changes",
    cancel: "Cancel",
    add: "Add",
    userDetailsUp: "User details updated successfully",
    pleaseSaveToResetThe: "Please save to reset the password.",
    createdDate: "Account Creation Date",
    firstLogin: "First Time Login",
    lastLogin: "Last Time Login",
    resetSecurityQuestionsSuccess: "User security questions have been reset successfully!",
    resetSecurityQuestionsFailed: "Failed to reset security questions",
    resetSecurityQuestionsError: "Error resetting security questions",
  },
  subjectManagement: {
    searchFilter: "Search filter",
    campaign: "Functional Unit",
    department: "Department",
    lastEdited: "Last Edited",
    date: "Date",
    subjectFor: "Subject For",
    status: "Status",
    country: "Country",
    coachingCategory: "Coaching Category",
    subCategory: "Sub-category",
    dataType: "Data Type",
    conditionToPass: "Condition to pass",
    framework: "Framework",
    enterSubCategory: "Enter sub-category",
    selectType: "Select type",
    selectCondition: "Select conditon to pass",
    selectFramework: "Select framework",
    addSubCategory: "Add sub-category",
    skillToImprove: "Skill to improve",
    enterSkillToImprove: "Enter skill to improve",
    addLevel: "Add Level",
    addSkillToImprove: "Add Skill to improve",
    actionAtCheckpoint: "Action At Checkpoint",
    enterAction: "Enter Action",
    addAction: "Add action",
    saveChanges: "Save changes",
    cancel: "Cancel",
    editSubject: "Edit Subject",
    subjectDetails: "Subject Details Updated",
    noRecordFound: "No record found",
    somethingWentWrong: "Something went wrong please try again later..!",
    functionalUnit: "Sub Functional Unit",
  },
  changePassword: {
    enterYourCurrentPassowrd: "Enter your current password",
    chooseAStrongPassword:
      "Choose a strong password and don't reuse it for other accounts",
    newPassword: "New password",
    passwordStrength: "Password strength",
    useAtLeast12Charecters:
      "Use at least 12 characters. Don’t use a password from another site, or something too obvious",
    confirmNewPassword: "Confirm new password",
    changePassword: "Change password",
    thePasswordDoNotMatch: "Passwords do not match",
    passwordMustBeAtLeast12:
      "Password must be at least 12 characters long, one number, one special character and one upper case letter",
    passwordCannotBeSameAsOldPassword:
      "New password cannot be same as old password",
    linkExpired: "Uh-oh, link expired or has already been used",
    linkExpiredMessage:
      "The link you followed is no longer valid. Please start over at login.",
    backToLogin: "Back to Login",
  },
  error: {
    loginerror:
      "Uh-oh, either your details are incorrect, or your account’s inactive",
    otperror: "Invalid OTP, please try again",
    usererror: "User is not active",
    internalServerError: "Something went wrong, please try again",
    networkerror: {
      500: "Something went wrong",
    },
    paramerror: "'Value of {{property}} can not be null.",
    passwordvalidationerror:
      "Password must be at least 10 characters long, one number, one special character and one upper case letter",
    newpasswordvalidationerror:
      "New password and confirm password doesn't match",
    oldpasswordvalidationerror: "Old password doesn't match",
    successpasswordvalidationerror: "Password successfully changed",

    noSessionDetailsFound: "No session details found",
    verbalWarningIssued: "Verbal warning issued",
    verbalWarningIssueFailed: "Failed to issue verbal warning, try again",
    alreadyTwoVerbalWarningIssued:
      "Already 2 verbal warning issued, try for other",
    checkpointProgressScoreHasBeenSavedSuccessfully:
      "Checkpoint Progress Score has been saved successfully",
    updatedCheckpointsSuccessfully: "Updated Checkpoints successfully",
    sessionReviewSummaryHasBeenSavedSuccessfully:
      "Session Review Summary has been saved successfully",
    selectedCoachIsAlreadyInTheList: "Selected Coach is already in the list",
    somethingWentWrongPleaseTryAgain: "something went wrong, please try again",
    couldNotGetSession: "Could not get session.",
    selectedCoacheeIsAlreadyBeenAdded: "Selected coachee is already been added",
    selectedCountryIsAlreadyInTheList:
      "Selected Country is already in the list",
    canNotUpdateActionAtCheckPoint: "can't update action_at_checkpoint!",
    couldNotGetCountryList: "Could not get Country List",
    couldNotGetNotification: "Could not get notification",
    errorGettingReviewDateSummary: "Error getting Review Date Summary",
    pleaseSelectCoachee: "Please select Coachee",
    couldNotGetGrowFormDetailsFromSessionId:
      "Could not get grow form details from session id",
    pleaseSelectSubjectAndAddMetrics: "Please select subject and add metrics",
    couldNotGetSkillsListBasedOnSubjectId:
      "Could not get Skills list based on subject id",
    blockedUser: "The user is blocked. Please try again after 60 min",
  },
  common: {
    copyright: "Copyright © 2021 TDCX. All Rights Reserved.",
    noRecordFound: "No record found",
    backToSession: "BACK TO SESSIONS",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
  },
  login: {
    emailCode:
      "A 6-digit code has been sent to your inbox! Enter it below to continue. Can’t find it? Check Spam or Junk.If you need more help.",
    checkGuide: "check out our guide",
    otpResetCode: "A 6-digit code has been sent to your inbox",
    otpResetCodeHint: "Enter the code to continue. Can't find it? Try looking in the Spam or Junk folder.",
    otpResetNoCode: "Didn't get a code?",
    otpResetNewCodeIn: "Resend in",
    otpResetCodeExpired: "Code validity expired?",
    otpResetRequestCode: "Request again",
    otpError:
      "<strong>Uh-oh,</strong> your code has either expired or is entered incorrectly – check again and give it another try. You've got {{count}} attempts remaining.",
    noCode: "Didn't get it?",
    newCodeIn: "Resend my code in",
    newCode: "Resend my code",
    verifyEmail: "Verify Email",
    codeSent: "A new verification code has been sent to your email.",
    fillOtpProperly: "Please fill the OTP properly",
    resendFailed: "Failed to resend code. Please try again.",
    rescanFailed: "Failed to fetch QR code. Please try again.",
    authenticatorReset: "Access restored. Log in and scan your new QR code.",
    tooManyAttempts: "Whoops, number of attempts exceeded. Don't worry, you can try again in 15 minutes.",
    sessionExpired: "Your session has expired. Please log in again.",
    somethingWentWrong: "Something went wrong, please try again",
    firstTimeLink: "First time logging in?",
    firstTimeTitle: "Logging in for the first time",
    firstTimeIntro:
      "Your Flash Coach credentials come from your TDCX employee profile.",
    firstTimeUsernameLabel: "Username",
    firstTimeUsername:
      "— your Flash Home <hl>Username</hl> (Flash Home → Profile → Personal Information).",
    firstTimePasswordLabel: "Password",
    firstTimePassword: "— your <hl>Employee ID</hl>, for this first login only.",
    firstTimeCaption:
      "People Profile page — your <hl>Employee ID (Password)</hl> and <hl>Username</hl> are in the fields highlighted above.",
    firstTimeNoteLabel: "Note:",
    firstTimeNote:
      "Right after logging in, you'll be required to set your own password before you can continue. This is mandatory — your Employee ID is only valid for this first login.",
    firstTimeGotIt: "Got it",
    firstTimeClose: "Close",
    firstTimeImageAlt:
      "Flash Home People Profile page, with the Employee ID field (used as your password) and the Username field highlighted.",
  },
  qrInput: {
    header2fa: "Enter the 6-digit code from your authenticator app",
    subtext: "Make sure your code is entered correctly, and hasn't expired. Need more help? ",
    checkGuide: "Check our complete guide.",
    otpError: "<strong>Uh-oh,</strong> your code has either expired or is entered incorrectly – check again and give it another try. You've got {{count}} attempts remaining.",
    verify: "Verify",
  },
  qrInputDisplay: {
    header2fa: "Complete your 2-Step Verification",
    qrSubtext: "Scan the QR with the Google or Microsoft Authenticator App to generate your 6-digit verification code.",
    qrSubtextHelp: "Need more help?",
    qrGuide: "Check our complete guide.",
    qrNoUrl: "Please reach customer support to reset your QR code",
    qrGotCode: "I've gotten my code",
    qrScanAgain: "Scan QR Again",
  },
  setSecurityQuestion: {
    title: "Set up recovery questions",
    subtitle: "Recover access in case your authenticator app isn't working (e.g., removed authenticator app, lost, or replaced phone).",
    saved: "Security questions saved successfully",
    failed: "Failed to save security questions",
    pleaseComplete: "Please complete all 3 security questions",
    backToLogin: "Back to Login",
    continue: "Continue",
  },
  resetSecurityQuestion: {
    title: "Recover your access",
    subtitle: "Answer the following questions to get back into Flash Coach.",
    placeholder: "Enter answer",
    continue: "Continue",
    backToLogin: "Back to Login",
    attemptsLeft: "Hmm, that looks incorrect. You have <strong>{{count}} attempt(s)</strong> left. Try again?",
    failedLoad: "Failed to load security question",
    missingToken: "Missing or invalid token. Please log in again.",
    verificationSuccess: "Verification successful",
    verificationFailed: "Verification failed",
    pleaseAnswer: "Please enter your answer",
  },
  changeSecurityQuestion: {
    title: "Change recovery questions",
    save: "Save Changes",
    verifyIdentity: "Help us confirm your identity to protect your account.",
    verifyPassword: "Enter your password",
    continue: "Continue",
    differentQuestions: "Want different recovery questions? Simply select, enter answers, and save changes!",
    passwordVerified: "Password verified",
    invalidPassword: "Invalid password",
    failedVerify: "Failed to verify password",
    updated: "Security questions updated successfully",
    failedUpdate: "Failed to update security questions",
    pleaseVerifyFirst: "Please verify your password first",
    pleaseComplete: "Please complete all 3 security questions",
  },
  campaignManagement: {
    functionUnit: "Functional unit",
    subFunctionUnit: "Sub Functional Unit",
    regionName: "Region Name",
    emailOtp: "Email Otp",
    extLink: "External Link",
  },
  regionManagement: {
    title: "Title",
    regionCode: "Region Code",
    emailOtp: "Email Otp",
  },
  promptTemplate: {
    title: "Prompt Templates",
    create: "Create Template",
    createTitle: "Create Prompt Template",
    editTitle: "Edit Prompt Template",
    name: "Name",
    templateType: "Template Type",
    selectType: "Select Type",
    promptContent: "Prompt Content",
    description: "Description",
    searchPlaceholder: "Search by name...",
    deleteTitle: "Delete Template",
    deleteMessage: "Are you sure you want to delete this template?",
  },
  nudgeLog: {
    sessionsTitle: "Nudge Logs - Sessions",
    sessionsSubtitle: "View all sessions with AI nudge logs",
    totalSessions: "Total Sessions",
    totalNudges: "Total Nudges",
    totalCost: "Total Cost",
    viewDetails: "View Details",
    noSessionsFound: "No sessions with nudge logs found",
    filterByModel: "Filter by model...",
    allTypes: "All Types",
    sessionTitle: "Nudge Logs - Session",
    userTitle: "Nudge Logs - User",
    analyticsTitle: "Nudge Logs Analytics",
  },
  aiPopover: {
    label: "AI assist",
    tooltip: "AI may be inaccurate—use as a guide.",
    helpful: "Helpful",
    notHelpful: "Not helpful",
    regenerate: "Regenerate",
    copy: "Copy summary",
    copied: "Copied!",
    enabledNotification: "AI assist is now on",
  },
  aiInsight: {
    assist: "AI assist",
    insight: "Insightful Response",
  }
};
